export default __webpack_public_path__ + "static/media/logo.cea86c1c.svg";